$('.reel-product-section').slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  centerMode: false, // Set to true for better centering
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: true, // Enable center mode for smaller screens
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false, // Enable center mode for smaller screens
      }
    }
  ]
});

 document.addEventListener('mousemove', function(e) {
        let fairyDust = document.createElement('div');
        fairyDust.classList.add('fairy-dust');
        document.body.appendChild(fairyDust);
        
        // Set the position of the fairy dust
        fairyDust.style.left = e.pageX + 'px';
        fairyDust.style.top = e.pageY + 'px';

        // Generate pastel colors for the flakes
        const pastelColors = ['#FFB3BA', '#FFDFBA', '#FFFFBA', '#BAFFC9', '#BAE1FF', '#E0BBE4'];
        let randomColor = pastelColors[Math.floor(Math.random() * pastelColors.length)];
        fairyDust.style.background = randomColor;
        fairyDust.style.boxShadow = `0 0 10px ${randomColor}`;

        // Remove the flake after the animation ends
        setTimeout(() => {
            fairyDust.remove();
        }, 1500);
    });

